"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppFooter = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Container = require("./Container.js");
var _Copyright = require("./Copyright.js");
var _Item = require("./Item.js");
var _List = require("./List.js");
var _excluded = ["list", "copyrightYear"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * AppFooter is the standard footer used across all Web applications.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-app-appfooter--docs) |
 * [Encore site](https://encore.spotify.net/web/components/app-layout#appfooter) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AppFooter) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?node-id=262-127)
 */
var AppFooter = exports.AppFooter = /*#__PURE__*/_react["default"].forwardRef(function AppFooter(_ref, ref) {
  var _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    copyrightYear = _ref.copyrightYear,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement("nav", null, /*#__PURE__*/_react["default"].createElement(_List.List, null, list.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_Item.Item, {
      key: /*#__PURE__*/(0, _react.isValidElement)(item) && item.key ? item.key : i
    }, item);
  }))), copyrightYear && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Copyright.Copyright, {
    variant: "marginal",
    translate: "no"
  }, "\xA9 ", copyrightYear, " Spotify AB")));
});